
import React from 'react';
import BaseComponent from './Base';

//کامپوننت واریزی ها
class Cashes extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : 'cashes',
        filterParams: [
          {value:'',name:"t",type:"string",default:''},
          {value:'',name:"b",type:"string",default:''},
        ]
      };

      super(props, config);
    }
    componentWillReceiveProps(props){
      this.setSearchValues("t","");
      this.setSearchValues("b","");
      this.state.data = null;
      this.state.filter = (props.filter !== undefined ? props.filter : "");
      this.setFilterParams();
      this.refresh();
    }
    getCashIncOrDecType(_c){
      if (_c.type === 2 || _c.type === 5 || _c.type === 7 || _c.type === 8 || _c.type === 9 || _c.type === 10 || _c.type === 12)
        return 1;
      else
        return 0;
    }
    render() {
      if (this.state.data === null || this.state.data === undefined)
        return this.showLoading();
      if (this.state.data.status === 500 || this.state.data.status === 0)
        return this.render500()
      if (this.state.data.status === 404)
        return this.render404()
      if (this.state.data.status === 2)
        return this.renderNoAccess()
      if (this.state.data.status === 4)
        return this.renderNoLogin();
      return (
        <div>  
          <div className='row'>
            {this.state.data.credits.map(_t=>
              <div className="col-md-12 col-sm-12 col-xs-12">
                <div className="box box-info">
                  <div className="box-header with-border">
                    <h3 className="box-title" style={{"display":"block"}}>
                        {this.getAccessTitle(_t)}
                        {_t.credit>0 ?
                          <span className="label label-info pull-left mr-r-5">{_t.credit} اعتبار</span>
                        :null}
                        {_t.limit_dl_to_ip === 1 ?
                          <span className="label label-danger pull-left mr-r-5">دانلود فایل مقالات فقط از طریق آی پی</span>
                        :null}
                        {_t.CivilicaAccessDate !== null ?
                          <span className="label label-warning pull-left mr-r-5">انقضا دسترسی {this.g2j(_t.CivilicaAccessDate)}</span>
                        :null}                          
                    </h3>
                  </div>
                </div>
              </div>
            )}
          </div> 
          {this.state.data.records.length > 0 ?
            <div className="row">
              {this.state.data.records.map(_t=>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className={this.getCashIncOrDecType(_t) === 1 ? "box box-success" : "box box-danger"}>
                    <div className="box-header with-border">
                      <h3 className="box-title" style={{"display":"block"}}>
                        نوع سند: {this.enumString(_t.type,"type")}
                        <span className="label label-success pull-left mr-r-5">شماره سند: {_t.id}</span>
                        <span className="label label-info pull-left"><i className="fal fa-clock"></i> {this.g2j(_t.date,6)}</span>
                      </h3>
                    </div>
                    <div className="box-body">
                      <ul className="products-list product-list-in-box">
                        <div className="item">
                          {_t.gateway_id !== null && _t.gateway_id !== '' ?
                            <span className="message mr-l-5">
                                بانک: {this.enumString(_t.gateway_id,"gateway_id")}
                            </span>
                          :null}
                          <span className="message mr-l-5">
                          {_t.price !== '' && _t.price !== '0' && _t.price !== null ?
                            <b>مبلغ: {this.money(_t.price)} ریال</b>
                          :null}
                          {_t.credit !== '' && _t.credit !== '0' && _t.credit !== null ?
                            <b>
                              {_t.price !== '' && _t.price !== '0' && _t.price !== null ?
                              " | "
                              :null}
                              اعتبار: {this.money(_t.credit)} عدد</b>
                          :null}
                           </span>
                          {_t.trace_code !== '' && _t.trace_code !== null ?
                            <span className="message mr-l-5">
                              &nbsp;| کد رهگیری: {this.money(_t.trace_code)}
                            </span>
                          :null}
                          {_t.number !== '' && _t.number !== null ?
                            <span className="message mr-l-5">
                              &nbsp;| شماره فیش/رسید: {this.money(_t.number)}
                            </span>
                          :null}   
                          {_t.note !== '' && _t.note !== null ?
                            <span className="message mr-l-5">
                             &nbsp;| توضیحات: {this.money(_t.note)}
                            </span>
                          :null}                        
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          :
            <h4 className="alert alert-info text-center">کاربر گرامی در حال حاضر هیچ سند مالی برای این مرکز ثبت نشده است</h4>
          }
          {this.createPaging()}
        </div>
      );
    }
  }
  export default Cashes;